var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneFollowing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F27731",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.965 19.5925C17.045 21.715 18.785 23.4475 20.9075 24.535L22.5575 22.885C22.76 22.6825 23.06 22.615 23.3225 22.705C24.1625 22.9825 25.07 23.1325 26 23.1325C26.4125 23.1325 26.75 23.47 26.75 23.8825V26.5C26.75 26.9125 26.4125 27.25 26 27.25C18.9575 27.25 13.25 21.5425 13.25 14.5C13.25 14.0875 13.5875 13.75 14 13.75H16.625C17.0375 13.75 17.375 14.0875 17.375 14.5C17.375 15.4375 17.525 16.3375 17.8025 17.1775C17.885 17.44 17.825 17.7325 17.615 17.9425L15.965 19.5925Z",
    fill: "#F27731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFollowing);
export default __webpack_public_path__ + "static/media/phoneFollowing.81316c66160b732aeadf189b31eec173.svg";
export { ForwardRef as ReactComponent };